/**
 * This utility patches the addEventListener method to make all ApexCharts
 * touch event listeners passive by default, fixing the browser warning:
 * "Added non-passive event listener to a scroll-blocking 'touchstart' event"
 */

export const patchApexChartsPassiveTouch = () => {
  if (window._apexChartsEventsPatchApplied) return

  const originalAddEventListener = EventTarget.prototype.addEventListener

  const APEX_MATCH_SELECTORS = '.apexcharts-canvas, .apexcharts-svg, .apexcharts-graphical, .apexcharts-series, .apexcharts-xaxis, .apexcharts-yaxis, .apexcharts-legend, .apexcharts-tooltip, .apexcharts-toolbar, .apexcharts-zoom-rect, .apexcharts-selection-rect'
  const APEX_CLOSEST_SELECTORS = '.apexcharts-canvas, .apexcharts-inner, .apexcharts-toolbar'

  EventTarget.prototype.addEventListener = function (type, listener, options) {
    let modifiedOptions = options

    if (type.startsWith('touch')) {
      let applyPassive = false

      if (this instanceof Element) {
        // Check for specific ApexCharts classes on the element itself or its parents
        if (this.matches?.(APEX_MATCH_SELECTORS) || this.closest?.(APEX_CLOSEST_SELECTORS)) {
          applyPassive = true
        }
      } else if (this === window || this === document) {
        // Apply for global touch handlers on window or document
        applyPassive = true
      }

      if (applyPassive) {
        if (typeof options === 'object' && options !== null) {
          // Options is an object, spread it and add/overwrite passive
          modifiedOptions = { ...options, passive: true }
        } else {
          // Options is boolean (for capture), undefined, or null
          // If boolean, it's used for capture. Otherwise, capture is effectively false.
          modifiedOptions = { capture: !!options, passive: true }
        }
      }
    }
    return originalAddEventListener.call(this, type, listener, modifiedOptions)
  }

  window._apexChartsEventsPatchApplied = true
}